import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  copyQuestions,
  getQuestionData,
} from "../../redux/services/questionSlice";
import Loader from "../../common/Loader";
import Pagination from "../../common/pagination";
import { customStyles } from "../../common/SelectStyle";
import Select from "react-select";
import { getClasses } from "../../redux/services/classesSlice";
import { getSubjectList } from "../../redux/services/subjectSlice";
import { BiSearch } from "react-icons/bi";
import { toast } from "react-toastify";

const CopyQuestions = () => {
  const dispatch = useDispatch();
  const questionData = useSelector((state) => state?.question?.questionData);
  const questionLoading = useSelector(
    (state) => state?.question?.questionLoading
  );
  const getClassesData = useSelector((state) => state?.classes?.classesData);
  const getSubjectListData = useSelector((state) => state?.subject?.subjectListData);
  
  const [classesFilter, setClasssesFilter] = useState("");
  const [moveClassesFilter, setMoveClassesFilter] = useState([]);
  const [moveSubjectFilter, setMoveSubjectFilter] = useState();
  const [subjectFilter, setSubjectFilter] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [page, setPage] = useState(0);
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
  const limit = 10;
  const getSubjectWiseQuestion = useCallback(async () => {
    try {
      await dispatch(
        getQuestionData({
          page: page + 1,
          limit: pageLimit,
          classesFilter: classesFilter,
          subjectFilter: subjectFilter,
          search: searchData,
        })
      );
    } catch (error) {}
  }, [page, pageLimit, classesFilter, subjectFilter, searchData, dispatch]);
  useEffect(() => {
    const fetchClasses = async () => {
      await dispatch(getClasses({ page: 1, limit: 100 }));
    };
    fetchClasses();
  }, [dispatch]);

  useEffect(() => {
    getSubjectWiseQuestion();
  }, [getSubjectWiseQuestion]);
  const CopyQuestions = async () => {
    try {
      let payload = {
        questionIds: selectedQuestions,
        classesIds: moveClassesFilter,
        subjectId: moveSubjectFilter,
      };
      if (selectedQuestions.length > 0 && moveClassesFilter.length > 0) {
        const response = await dispatch(copyQuestions(payload));
        if (response?.payload?.status === 201) {
          toast.success(response?.payload?.message, {
            autoClose: 2000,
            pauseOnHover: false,
          });
          setSelectedQuestions([]);
          setMoveClassesFilter([]);
        }
      }
    } catch (error) {}
  };
  const classOptions =
    getClassesData?.classes_data?.map((contestType) => ({
      value: contestType._id,
      label: contestType.name,
    })) || [];
  const subjectOptions = getSubjectListData?.map((sub) => ({
      value: sub._id,
      label: sub.name,
    })) || [];
  const handleQuestionSelect = (questionId) => {
    if (selectedQuestions.includes(questionId)) {
      setSelectedQuestions(selectedQuestions.filter((id) => id !== questionId));
    } else {
      setSelectedQuestions([...selectedQuestions, questionId]);
    }
  };

  const handleSelectAll = () => {
    if (selectedQuestions.length === questionData?.question_data?.length) {
      setSelectedQuestions([]);
    } else {
      const allQuestionIds = questionData?.question_data?.map(
        (question) => question._id
      );
      setSelectedQuestions(allQuestionIds);
    }
  };
  const getSubjectListApi = useCallback(async () => {
    try {
      await dispatch(
        getSubjectList()
      );
    } catch (error) {}
  }, [dispatch]);

  useEffect(() => {
    getSubjectListApi();
  }, [getSubjectListApi]);
  return (
    <div className="p-4">
      <section className="bg-card p-4 md:px-8 overflow-y-auto min-h-full rounded-xl border border-border font-sans">
        <div className="flex items-end justify-between flex-wrap gap-5">
          <div className="relative max-w-md w-full flex items-center h-fit gap-3">
            <p className="text-lg font-medium text-foreground">Search:</p>
            <input
              type="text"
              className="max-w-md w-full px-4 py-2 border rounded-xl focus:outline-none"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setSearchData(searchTerm);
                }
              }}
            />
            <button
              type="button"
              className="absolute top-0 right-0 px-4 h-full bg-primary text-white rounded-r-xl"
              onClick={() => setSearchData(searchTerm)}
            >
              <BiSearch />
            </button>
          </div>
          <div className="max-w-[300px] w-full">
            <label className="text-sm font-medium text-foreground">
              Classes Name
            </label>
            <Select
              className=""
              value={classOptions?.find(
                (option) => option.value === classesFilter
              )}
              onChange={(e) => setClasssesFilter(e.value)}
              options={classOptions}
              styles={customStyles}
            />
          </div>
          <div className="max-w-[300px] w-full">
            <label className="text-sm font-medium text-foreground">
              Subject Name
            </label>
            <Select
              className=""
              value={subjectOptions?.find(
                (option) => option.value === subjectFilter
              )}
              onChange={(e) => setSubjectFilter(e.value)}
              options={subjectOptions}
              styles={customStyles}
            />
          </div>
        </div>
        <div className="flex justify-between flex-wrap mt-5">
          <h2 className="text-2xl font-semibold text-foreground">Questions</h2>
          {questionData?.totalData && (
            <p className="text-xl font-semibold text-foreground">
              Total Questions : {questionData?.totalData}
            </p>
          )}
        </div>

        {questionLoading ? (
          <Loader />
        ) : (
          <div className="w-full space-y-6 md:gap-16 font-sans mt-4">
            {questionData?.question_data?.length > 0 ? (
              <ul className="space-y-4">
                <div className="flex justify-between flex-wrap-reverse gap-3">
                  <li className="flex items-center">
                    <input
                      type="checkbox"
                      checked={
                        selectedQuestions.length ===
                        questionData?.question_data?.length
                      }
                      onChange={handleSelectAll}
                      className="mr-2"
                    />
                    <span>Select All</span>
                  </li>
                  <div className="flex items-end gap-4">
                    <div className="min-w-[300px] w-full gap-4">
                      <label className="text-md font-medium whitespace-nowrap text-foreground">
                        Move Classes Name
                      </label>

                      <Select
                        isMulti
                        value={classOptions.filter((option) =>
                          moveClassesFilter.includes(option.value)
                        )}
                        onChange={(selectedOptions) =>
                          setMoveClassesFilter(
                            selectedOptions.map((option) => option.value)
                          )
                        }
                        options={classOptions}
                        styles={customStyles}
                      />
                    </div>
                    <div className="min-w-[300px] w-full gap-4">
                      <label className="text-md font-medium whitespace-nowrap text-foreground">
                        Move Subject Name
                      </label>
                      <Select
                        className=""
                        value={subjectOptions?.find(
                          (option) => option.value === moveSubjectFilter
                        )}
                        onChange={(e) => setMoveSubjectFilter(e.value)}
                        options={subjectOptions}
                        styles={customStyles}
                      />
                    </div>
                    <button
                      className="bg-primary h-fit text-white px-4 py-2 rounded-xl font-semibold"
                      onClick={CopyQuestions}
                    >
                      Move
                    </button>
                  </div>
                </div>

                {questionData?.question_data?.map((value, index) => (
                  <li key={index} className="">
                    <div className="md:flex items-center justify-between text-lg font-medium text-foreground mt-5">
                      <div className="flex items-center gap-x-4">
                        <input
                          type="checkbox"
                          checked={selectedQuestions.includes(value._id)}
                          onChange={() => handleQuestionSelect(value._id)}
                          className="mr-2"
                        />
                        <p className="text-lg font-medium text-foreground capitalize">
                          {page * limit + index + 1}
                        </p>
                        <p className="text-lg font-medium text-foreground capitalize">
                          {value?.englishQuestion?.question}
                        </p>
                      </div>
                      <div className="flex items-center justify-end space-x-4 pr-2 md:mt-0 mt-2">
                        <span
                          className={`${
                            value.type === "concept"
                              ? "bg-green-100 text-green-600"
                              : value.type === "aptitude"
                              ? "bg-yellow-100 text-yellow-600"
                              : value.type === "random"
                              ? "bg-red-100 text-red-600"
                              : "bg-background text-foreground"
                          } px-4 text-sm leading-8 font-medium rounded-full capitalize`}
                        >
                          {value.type}
                        </span>
                      </div>
                    </div>
                    <div className="rounded-xl border mt-3 border-border md:px-6 md:py-4 px-4 py-2 text-md text-justify font-normal text-muted-foreground shadow-inner ">
                      <p className="line-clamp-3">
                         
                        {value?.questionType === "statement"
                          ? value?.englishQuestion?.statementQuestion?.[0]
                              ?.combined
                          : null}
                        {value?.questionType === "normal"
                          ? value?.englishQuestion?.solution
                          : null}
                        {value?.questionType === "pair"
                          ? value?.englishQuestion?.pairQuestion?.[0]?.combined
                          : null}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="flex items-center justify-center p-4 h-full">
                <div className="text-center animate__animated animate__fadeIn animate__delay-1s">
                  <h2 className="font-heading text-xl sm:text-2xl font-bold text-primary mb-2 sm:mb-4">
                    No Data Found
                  </h2>
                  <p className="text-md text-muted-foreground mb-6">
                    Unfortunately, we couldn't find any results matching your
                    search.
                  </p>
                  <div className="mt-6">
                    <button
                      className="px-6 py-3 bg-primary text-white text-lg font-semibold rounded-xl shadow-theme hover:bg-accent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-all duration-300 ease-in-out transform hover:scale-105"
                      onClick={() => window.location.reload()}
                    >
                      Try Again
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        <div className="mt-4">
          {questionData?.state?.page_limit && (
            <>
              <div className="flex justify-between bg-card items-center px-4">
                <div className="flex items-center gap-2">
                  <label htmlFor="pageLimit" className="mr-2">
                    Page Limit:
                  </label>
                  <Select
                    className=""
                    value={limitOptions?.find(
                      (option) => option.value === pageLimit
                    )}
                    onChange={(e) => setPageLimit(e.value)}
                    options={limitOptions.map((option) => ({
                      value: option.value,
                      label: option.label,
                    }))}
                    styles={customStyles}
                    menuPlacement="top"
                  />
                </div>
                <Pagination
                  pageCount={questionData?.state?.page_limit}
                  onPageChange={(data) => setPage(data.selected)}
                />
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
};

export default CopyQuestions;
